import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-black text-white flex items-center justify-center" }
const _hoisted_2 = { class: "max-w-md w-full px-6 py-8 bg-gray-900 rounded-lg" }

import { ref } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter } from 'vue-router'
  import request from '@/utils/request'
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

  const store = useStore()
  const router = useRouter()
  const username = ref('')
  const password = ref('')
  
  const handleLogin = async () => {
    try {
      const formData = new FormData()
      formData.append('username', username.value)
      formData.append('password', password.value)
      
      const res = await request.post('/auth/login', formData)
      console.log(res)
      if (res.data.access_token) {
        store.commit('setToken', res.data.access_token)
        alert('登录成功')
        router.push('/')
      }
    } catch (error) {
      alert('登录失败')
    }
  }
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-2xl font-bold text-center mb-8" }, "登录", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleLogin, ["prevent"]),
        class: "space-y-6"
      }, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block mb-2" }, "用户名", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
            type: "text",
            class: "w-full bg-gray-800 rounded px-4 py-2"
          }, null, 512), [
            [_vModelText, username.value]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block mb-2" }, "密码", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            type: "password",
            class: "w-full bg-gray-800 rounded px-4 py-2"
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          type: "submit",
          class: "w-full bg-yellow-500 text-black py-2 rounded"
        }, " 登录 ", -1))
      ], 32)
    ])
  ]))
}
}

})